// extracted by mini-css-extract-plugin
export default {"root":"panel__root__vYJYa","mainPanel":"panel__mainPanel__lE95p","leftPanel":"panel__leftPanel__JvQpO","leftPanelBackground":"panel__leftPanelBackground__p6wYg"};